import { render, staticRenderFns } from "./HomeShopping.vue?vue&type=template&id=529483ff&"
import script from "./HomeShopping.vue?vue&type=script&lang=js&"
export * from "./HomeShopping.vue?vue&type=script&lang=js&"
import style0 from "./HomeShopping.vue?vue&type=style&index=0&id=529483ff&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports